const DEV_FALLBACK = 'http://localhost:5000';

/** API base URL (no trailing slash). CRA only injects REACT_APP_* at build/start time. */
export function getServerUrl() {
  const url =
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_SERVER_URL_LOCAL || DEV_FALLBACK
      : process.env.REACT_APP_SERVER_URL;

  if (!url) {
    if (process.env.NODE_ENV === 'development') {
      return DEV_FALLBACK;
    }
    console.warn(
      '[Candy Haven] REACT_APP_SERVER_URL is missing. Add it to client/.env and restart npm start.'
    );
    return '';
  }

  return url.replace(/\/$/, '');
}
